import { WAREHOUSE_ADDRESSES_ACTIONS, initialWarehouseAddressesState } from './warehouseAddresses.types'

/**
 * @param {import('./warehouseAddresses.types').WarehouseAddressesSlice} state
 * @param {Object} action
 */
export function warehouseAddressesReducer(state = initialWarehouseAddressesState, { type, payload }) {
  switch (type) {
    case WAREHOUSE_ADDRESSES_ACTIONS.SET_WAREHOUSE_ADDRESSES:
      return { ...state, data: payload }

    case WAREHOUSE_ADDRESSES_ACTIONS.SET_WAREHOUSE_ADDRESS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case WAREHOUSE_ADDRESSES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case WAREHOUSE_ADDRESSES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case WAREHOUSE_ADDRESSES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
